import { BrowserRouter, Route, Routes } from "react-router-dom";
import MacaVanPhucApp from "../components/MacaVanPhucApp";
import AdminPage from "../components/AdminPage";
import NotFoundPage from "../components/NotFoundPage";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MacaVanPhucApp />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
